import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import FiltrosPrazo from '../../components/common/FiltrosPrazo';
import TabelaPrazos from '../../components/common/TabelaPrazos';
import useFiltroVencimentos from '../../hooks/useFiltroVencimentos';
import { useNomePorHospital } from './dashboardHelpers';

// Versão "carteira inteira" da tela de vencimentos — a versão por hospital vive em
// pages/hospitais/AbaVencimentos.jsx e compartilha os mesmos FiltrosPrazo/TabelaPrazos.
export default function PortfolioVencimentos({ hospitais, avaliacoesPorHospital }) {
  const navigate = useNavigate();
  const nomePorHospital = useNomePorHospital(hospitais);

  const base = useMemo(() => {
    const itens = [];
    Object.entries(avaliacoesPorHospital).forEach(([idHospital, avaliacoes]) => {
      avaliacoes.forEach((a) => itens.push({ ...a, idHospital, nomeHospital: nomePorHospital.get(idHospital) }));
    });
    return itens;
  }, [avaliacoesPorHospital, nomePorHospital]);

  const filtro = useFiltroVencimentos(base, { campoData: 'data_vencimento_vigencia' });

  return (
    <div>
      <div className="mb-3">
        <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--am-tinta)' }}>
          Critérios próximos do vencimento
        </div>
        <p style={{ fontSize: 13, color: 'var(--am-cinza-texto-2)', margin: '4px 0 0', maxWidth: 480 }}>
          Vigências que vencem nos próximos {filtro.dias} dias ou já vencidas, em todos os hospitais.
        </p>
      </div>

      <FiltrosPrazo {...filtro} />

      <TabelaPrazos
        itens={filtro.vencimentos}
        campoData="data_vencimento_vigencia"
        colunaData="Vence em"
        vazioTexto="Nenhuma vigência encontrada com esses filtros."
        mostrarHospital
        onSelecionar={(v) => navigate(`/hospitais/${v.idHospital}?aba=mapa&requisito=${v.id_requisito}`)}
      />
    </div>
  );
}
